// extracted by mini-css-extract-plugin
export default {"content":"AT","wrapper":"BT","gif":"CT","textContent":"ET","gifContainer":"FT","proteinGif":"GT","counter_img":"HT","usage-container":"IT","usage-list":"JT","checklist":"KT","counter_title":"LT","counter_wrapper":"MT","active":"NT","usage-counter":"OT","line":"PT"};
    if(module.hot) {
      // 1730991510014
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  